// Option lists transcribed from "2024 - Admissions Company Student Interview.xlsx".

export const SPORTS = [
  "Badminton",
  "Baseball (Boys)",
  "Basketball",
  "Bowling",
  "Cheerleading / Competitive Spirit Squads",
  "Cross Country",
  "Dance Team",
  "Field Hockey",
  "Flag Football (Girls)",
  "Football (Boys)",
  "Golf",
  "Gymnastics",
  "Hockey",
  "Indoor Track & Field",
  "Lacrosse",
  "Skiing & Snowboarding",
  "Soccer",
  "Softball (Girls)",
  "Slow Pitch Softball (Girls)",
  "Surf",
  "Swimming & Diving",
  "Tennis",
  "Track & Field",
  "Volleyball",
  "Water Polo",
  "Weightlifting",
  "Wrestling",
];

export const HOBBIES = [
  "Reading",
  "Writing",
  "Hiking",
  "Knitting",
  "Fishing",
  "Video Games",
  "Chess",
  "Gardening",
  "Programming",
  "Painting",
  "Robotics",
  "Camping",
  "Sailing",
  "Cooking",
  "Content Creation",
  "Photography",
  "Videography",
  "Baking",
  "Singing",
  "Rock Climbing",
  "Yoga",
  "Volunteering",
  "Horseback Riding",
  "Birdwatching",
  "Calligraphy",
  "Model Building",
  "Museum Hopping",
  "Travel",
  "Storytelling",
  "Pottery",
  "Carpentry",
  "Surfing",
  "Skating",
  "Journaling",
  "Acting",
  "Sketching",
  "Tutoring",
  "Web Design",
  "Coaching",
  "Archery",
  "Arts & Crafts",
  "Puzzles",
  "Meditation",
  "Astronomy",
  "Origami",
  "Needlepoint",
  "Poetry",
  "Quilting",
  "Board Games",
  "Crossword",
  "Fantasy Sports",
  "Model Trains",
  "Bonsai",
  "Karaoke",
  "Composting",
  "Scuba Diving",
  "Skydiving",
];
